import { config } from '../config';

// Crea un ObjectURL para imágenes/archivos del módulo Base de Conocimiento protegidos por token
export async function createKbObjectUrl(securePreviewUrl) {
    const token = (localStorage.getItem('token') || sessionStorage.getItem('token'));
    if (!token) throw new Error('Token no disponible');

    let fullUrl = securePreviewUrl;
    const apiBase = config.api.baseURL; // incluye /api
    const baseWithoutApi = apiBase.replace('/api', '');
    if (!securePreviewUrl.startsWith('http')) {
        // Si es ruta relativa de securefile, asegúrate de pegarla a la base DEL API (incluye /api)
        if (securePreviewUrl.startsWith('/securefile/')) {
            fullUrl = `${apiBase}${securePreviewUrl}`; // => http(s)://host/api/securefile/...
        } else {
            // Rutas estáticas fuera de /api
            fullUrl = `${baseWithoutApi}${securePreviewUrl}`;
        }
    } else {
        // Es absoluta. Si apunta al mismo host sin /api y es /securefile, reescribir a /api/securefile
        try {
            const u = new URL(securePreviewUrl);
            const baseHost = new URL(baseWithoutApi);
            if (u.host === baseHost.host && u.pathname.startsWith('/securefile/')) {
                fullUrl = `${apiBase}${u.pathname}${u.search}`;
            }
        } catch { }
    }

    const resp = await fetch(fullUrl, { headers: { Authorization: `Bearer ${token}` } });
    if (!resp.ok) throw new Error(`Error ${resp.status} cargando archivo`);
    const blob = await resp.blob();
    return URL.createObjectURL(blob);
}




